export const cursorIsVisible = ref(false);

export const setCursorVisibility = (value) => {
    cursorIsVisible.value = value;
};
